import { render, staticRenderFns } from "./GetTransaction.vue?vue&type=template&id=0d7590aa&scoped=true"
import script from "./GetTransaction.vue?vue&type=script&lang=js"
export * from "./GetTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7590aa",
  null
  
)

export default component.exports